import axios from "../axios"

const reviewTaskApi = {
	
	getTaskList(data) {
		return axios({//
			url: `/gzeua/Appraise/QueryAll`,
			method: "post",
			data
		})
	},
	
	getCompanyTaskList(data) {
		return axios({//查询角色列表
			url: `/gzeua/AppraiseCompany/QueryByCompany`,
			method: "post",
			data
		})
	},
	getReviewFormByID(appraiseComId) { 
		return axios({
			url: `/gzeua/AppraiseCompany/GetAppraiseCompanyRequest`,
			method: "post",
			params: {
				appraiseComId
			}
		})
	},
	getReviewModelByID(appraiseComId) { 
		return axios({
			url: `/gzeua/AppraiseCompany/GetAppraiseModel`,
			method: "post",
			params: {
				appraiseComId
			}
		})
	},
	addCompaniesToTask(appraiseId,idArr) {
		return axios({
			url: `/gzeua/AppraiseCompany/AddAppraiseCompanys`,
			method: "post",
			params:{appraiseId},
			data:idArr
		})
	},
	deleteCompanyFromTask(id) { 
		return axios({
			url: `/gzeua/AppraiseCompany/Delete`,
			method: "post",
			params: {
				id
			}
		})
	},
	changeTaskCompanyInfo(data) {
		return axios({
			url: `/gzeua/AppraiseCompany/UpdateBaseCompany2`,
			method: "post",
			data
		})
	},
	getCompaniesByTaskID(data) {
		return axios({
			url: `/gzeua/AppraiseCompany/QueryAll`,
			method: "post",
			data
		})
	},
	getSubmitByTaskID(appraiseComId) {
        return axios({
            url: "/gzeua/AppraiseCompany/GetAppraiseCompanyRequest",
            method: "post",
			params: {
				appraiseComId
			}
        })
    },
	submitReviewItemWithData(comrequestid, path, paraObj, dataObj) {
        console.info("submit with data")
        return axios({
            url: `/gzeua/AppraiseCompany/${path}?comrequestid=${comrequestid}`,
            method: "post",
            data: {},
            params: {
                ...paraObj
            },
            data: dataObj
        })
    },
	changeGSGBLevel(data){
		return axios({
            url: `/gzeua/AppraiseCompany/EditCompanyLevel`,
            method: "post",
            data
        })
	},
   
    submitReviewItem(comrequestid, path, paraObj) {
        console.info("submit without data")
        return axios({
            url: `/gzeua/AppraiseCompany/${path}?comrequestid=${comrequestid}`,
            method: "post",
            data: {},
            params: {
                ...paraObj
            },


        })
    },
	SubmitToAudit(appraiseComId) {
        return axios({
            url: "/gzeua/AppraiseCompany/SubmitToAudit",
            method: "post",
			params: {
				appraiseComId
			}
        })
    },
	saveFile({ uappcomid,seqnum,  formData, file,fileName }) {
		//secondPath  uappcomid/seqnum
        return axios({
            url: `/gzeua/Upload/file?path=gzeua&secondPath=${uappcomid+'/'+seqnum}&fileName=${fileName}`,
            method: "post",
            data: formData,
            file,
            processData: false,
            contentType: false,
        })
    },
	getStepByID(unitAppraiseId){
		return axios({
			url: `/gzeua/Appraise/QueryByUnitAppraiseId`,
			method: "post",
			params:{
				unitAppraiseId
			}
		})
	},
	getUserStep(){
		return axios({
			url: `/gzeua/User/GetUserFlowStepIds`,
			method: "post",
			// params:{
			// 	unitAppraiseId
			// }
		})
	},
	getAuditionList(data){
		return axios({
			url: `/gzeua/AppraiseCompany/QueryAll`,
			method: "post",
			data
		})
	},
	getPersonAuditionList(data){
		return axios({
			url: `/gzeua/AppraiseCompany/QueryForAppraise`,
			method: "post",
			data
		})
	},
	getEvaluateTargetList(data){
		return axios({
			url: `/gzeua/AppraiseAuds/Search`,
			method: "post",
			data
		})
	},
	saveEvaluateTargetItem(data){
		return axios({
			url: `/gzeua/AppraiseAuds/CreateOrEdit`,
			method: "post",
			data
		})
	},
	delEvaluateTargetByID(id){
		
		return axios({
			url: `/gzeua/AppraiseAuds/Delete`,
			method: "post",
			params:{
				id
			}
		})
	},
	getEvaluateTargetSubList(data){
		return axios({
			url: `/gzeua/AppraiseAudsItem/Search`,
			method: "post",
			data
		})
	},
	saveEvaluateTargetSubItem(data){
		return axios({
			url: `/gzeua/AppraiseAudsItem/CreateOrEdit`,
			method: "post",
			data
		})
	},
	delEvaluateTargetSubByID(id){
		
		return axios({
			url: `/gzeua/AppraiseAudsItem/Delete`,
			method: "post",
			params:{
				id
			}
		})
	},
	
}
export default reviewTaskApi
